import * as React from 'react';
import SVGIcon from '../SVGIcon';

interface Props {}

const LaunchIcon: React.FC<Props> = () => {
  return (
    <SVGIcon width="17" height="16" viewBox="0 0 17 16" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5 14C16.0523 14 16.5 14.4477 16.5 15C16.5 15.5523 16.0523 16 15.5 16L1.5 16C0.947715 16 0.5 15.5523 0.5 15C0.5 14.4477 0.947715 14 1.5 14L15.5 14ZM4.79289 7.29292L11.7929 0.292924C12.1534 -0.0675602 12.7206 -0.0952898 13.1129 0.209735L13.2071 0.292924L16.2071 3.29292C16.5676 3.65341 16.5953 4.22064 16.2903 4.61293L16.2071 4.70714L9.20711 11.7071C9.05083 11.8634 8.84815 11.9626 8.63144 11.9914L8.5 12H5.5C4.98716 12 4.56449 11.614 4.50673 11.1167L4.5 11L4.5 8.00003C4.5 7.77902 4.57316 7.56555 4.70608 7.392L4.79289 7.29292L11.7929 0.292924L4.79289 7.29292ZM12.5 2.41424L6.5 8.41424L6.5 10H8.08579L14.0858 4.00003L12.5 2.41424Z"
        fill="#187A90"
      />
    </SVGIcon>
  );
};

export default LaunchIcon;
